export const formatNumber = (value: number | string | null | undefined, unit: string): string => {
  const formattedUnit = unit ? ` ${unit}` : ''
  const num = Number(value)

  if (!Number.isFinite(num)) return `0${formattedUnit}`

  return num % 1 === 0
    ? `${num.toLocaleString('ru-RU', { maximumFractionDigits: 0 })}${formattedUnit}`
    : `${num.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}${formattedUnit}`
}

export const formatRoundedNumber = (
  value: number | string | null | undefined,
  unit: string,
): string => {
  const num = Number(value)
  const formattedUnit = unit ? ` ${unit}` : ''

  if (!Number.isFinite(num)) {
    return `0${formattedUnit}`
  }

  return `${Math.round(num).toLocaleString('ru-RU', { maximumFractionDigits: 0 })}${formattedUnit}`
}

export const formatRouteSheetLoadingTime = (value: string | null | undefined): string => {
  const trimmedValue = value?.trim()
  if (!trimmedValue) return ''

  if (trimmedValue.includes(' - ')) return trimmedValue

  return /^([01]\d|2[0-3]):[0-5]\d$/.test(trimmedValue)
    ? `${trimmedValue} - ${trimmedValue}`
    : trimmedValue
}
